export function toTitleCase(str: string): string {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase();
}

export function formatPhoneNumber(num: string): string {
  return num
    .replace(/\D/g, "")
    .replace(/^(\d{3})(\d{3})(\d{0,4})$/, "$1 $2 $3")
    .trim();
}

export function normalizePhone(code: string, phone: string) {
  const codeWithoutPlus = code.replace("+", "");
  const cleanPhone = phone.replace(/\D/g, "");
  return `${codeWithoutPlus}${cleanPhone}`;
}

export const onlyDigits = (v?: string) => (v || "").replace(/\D/g, "");
